<script>
    import infoIcon from './infoIcon';
    import showNote from '../utilities/showNote';

    export default {
        name: 'feesTable',

        props: {
            isCalc: null,
            isParis: null,
            fees: null
        },

        components: { infoIcon },

        methods: {
            showNote,
            getFee(fee) {
                return this.isParis ? (fee.amountParis ? fee.amountParis : fee.amount) : fee.amount;
            },
        }

    }
</script>

<template>
    <div class="a-tableWrapper" >
        <div class="a-tableWrapperSlider">
            <table v-if="fees.length" class="a-table--responsive a-table tf-table" >
                <thead>
                    <tr>
                        <th>Fee Type</th>
                        <th>Amount</th>
                        <th>Frequency</th>
                    </tr>
                </thead>
                <tbody>
                <tr v-for="(fee, index) in fees" :key="fee.id" :class="{'odd': index % 2 === 0}">
                    <td :class="{'tf-hasNote': fee.notes}" @click="showNote(fee, $event, 3)" >{{fee.fullName + '&nbsp;'}}<infoIcon v-if="fee.notes"/></td>
                    <td>{{getFee(fee) | toCurrency}}</td>
                    <td>{{fee.frequencyText}}</td>
                </tr>
                </tbody>
            </table>
            <p v-else class="tf-incompleteStep">Please complete Step 1 to see applicable fees.</p>
        </div>
    </div>
</template>
